import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      fontSize: theme.typography.pxToRem(12),
    },
  }),
  { name: 'EditorActionButton' }
);
